import { render, staticRenderFns } from "./funPresChanges.vue?vue&type=template&id=8c357dc6"
import script from "./funPresChanges.vue?vue&type=script&lang=js"
export * from "./funPresChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports